import { render, staticRenderFns } from "./DragDropTest.vue?vue&type=template&id=ac6214dc&scoped=true&"
import script from "./DragDropTest.vue?vue&type=script&lang=js&"
export * from "./DragDropTest.vue?vue&type=script&lang=js&"
import style0 from "./DragDropTest.vue?vue&type=style&index=0&id=ac6214dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6214dc",
  null
  
)

export default component.exports